import {Group, Button, Text} from '@mantine/core';

interface PaginationControlsProps {
    currentPage: number;
    hasNext: boolean;
    hasPrevious: boolean;
    onNext: () => void;
    onPrevious: () => void;
    loading?: boolean;
}

export const PaginationControls = ({
                                       currentPage,
                                       hasNext,
                                       hasPrevious,
                                       onNext,
                                       onPrevious,
                                       loading = false,
                                   }: PaginationControlsProps) => {

    if (!hasNext && !hasPrevious) {
        return null;
    }

    return (
        <Group justify="space-between" mt="md">
            <Button
                variant="default"
                size="xs"
                disabled={!hasPrevious || loading}
                onClick={onPrevious}
            >
                Previous
            </Button>
            <Text size="sm" c="dimmed">Page {currentPage}</Text>
            <Button
                variant="default"
                size="xs"
                disabled={!hasNext || loading}
                onClick={onNext}
            >
                Next
            </Button>
        </Group>
    );
};
